// =============================================================================
// FILE PATH: src/modules/pms/services/userBpMappingService.js
// =============================================================================

import axiosClient from "../../../api/axiosClient";

// GET EMPLOYEES
export const getEmployees = () => {
   return axiosClient.get("/employees/assignable");
};

// GET ASSIGNABLE BP
export const getAssignableBusinessPartners = () => {
  return axiosClient.get("/api/pms/assignable-business-partners");
};

export const saveUserBPMapping = (payload) => {
  return axiosClient.post("/api/pms/user-bp-map", payload);
};
export const getUserBPMappingList = () => {
  return axiosClient.get("/api/pms/user-bp-map");
};

export const deleteUserBPMapping = (employeeId) => {
  return axiosClient.delete(`/api/pms/user-bp-map/${employeeId}`);
};

